import React, { useCallback } from "react";
import Particles from "react-particles";
import { loadSlim } from "tsparticles-slim";

const ParticlesBackground = () => {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: -1, // Ensure it stays behind other content
    }}>
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          particles: {
            number: {
              value: 100,
              density: {
                enable: true,
                value_area: 750,
              },
            },
            color: {
              value: "rgba(94,77,224,1)", // Blue dots
            },
            links: {
              enable: true,
              color: "rgba(94,77,224,1)", // Default gray color
              distance: 100,
              opacity: 0.4,
              width: 0.3,
            },
            move: {
              enable: true,
              speed: 1.5,
            },
            size: {
              value: 1.2,
            },
            opacity: {
              value: 0.9,
            },
          },
          interactivity: {
            events: {
              onHover: {
                enable: true,
                mode: "connect", // Enables color change on hover
              },
            },
            modes: {
              connect: {
                distance: 150,
                links: {
                  opacity: 0.6,
                  color: "rgba(94,77,224,1)", // Changes link color on hover
                },
              },
            },
          },
          background: {
            color: "#f5f5f5",
          },
        }}
      />
    </div>
  );
};

export default ParticlesBackground;